import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {
  ClassTask,
  ClassTaskResponse,
  Subtask,
  SubtaskProgress,
  Status,
  ClassTaskService
} from "../../services/class-task.service";
import {FadeInOut} from "../../animations";
import {firstValueFrom} from "rxjs";
import {Assessment} from "../../services/volunteer-task.service";
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClassTaskRewardsComponent } from '../class-task-rewards/class-task-rewards.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgFor, NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

interface Datum {
  subtask: Subtask ;
  progress: SubtaskProgress ;
}

@Component({
    selector: 'app-classtask',
    templateUrl: './classtask.component.html',
    styleUrls: ['./classtask.component.scss'],
    animations: [FadeInOut(true)],
    standalone: true,
    imports: [NgFor, NgIf, FaIconComponent, ClassTaskRewardsComponent, MatTooltipModule, MatButtonModule]
})
export class ClasstaskComponent implements OnInit, OnChanges {

  @Input()
  task?: ClassTask ;

  @Input()
  response?: ClassTaskResponse ;

  subtasks: Datum[] = [] ;

  @Input()
  assessing: boolean = false ;

  @Input()
  subtaskIndex?: number ;

  constructor(
    private $tasks: ClassTaskService
  ) {

  }

  ngOnInit(): void {

    this.subtasks = [];

    for (let i=0 ; i<this.task!.subtasks.length ; i++) {

      let progress = new SubtaskProgress('PENDING') ;
      if (this.response) {
        progress = this.response.subtaskProgress[i];
      }

      this.subtasks.push({
        subtask: this.task!.subtasks[i],
        progress: progress
      })
    }



    this.handleProgressChanged();

    //calculate milestone index
  }

  private handleProgressChanged() {

    if (!this.task || !this.subtasks.length)
      return ;

    for (let i=0 ; i<this.task.subtasks.length ; i++) {
      if (this.response) {
        this.subtasks[i].progress = this.response.subtaskProgress[i];
      } else {
        this.subtasks[i].progress = new SubtaskProgress('PENDING') ;
      }
    }

    if (this.subtaskIndex === undefined) {
      if (this.assessing) {
        this.subtaskIndex = this.earliestUnassessedMilestone ;
      } else {
        this.subtaskIndex = this.earliestIncompleteMilestone ;
      }
    }

    if (this.subtaskIndex === undefined) {
      this.subtaskIndex = 0 ; //this.task.subtasks.length - 1 ;
    }
  }

  get earliestIncompleteMilestone(): number | undefined {

    if (!this.response) {
      return undefined ;
    }

    for (let i=0 ; i<this.response.subtaskProgress.length ; i++) {
      let mp = this.response.subtaskProgress[i] ;
      if (mp.status == "ATTEMPTING" || mp.status == "PENDING") {
        return i ;
      }
    }
    return undefined ;
  }

  get earliestUnassessedMilestone(): number | undefined {
    if (!this.response) {
      return undefined ;
    }
    for (let i=0 ; i<this.response.subtaskProgress.length ; i++) {
      let mp = this.response.subtaskProgress[i] ;
      if (mp.status == "AWAITING_ASSESSMENT") {
        return i ;
      }
    }
    return undefined ;
  }


  async updateSubtaskProgress(index: number, status?:Status, assessment?:Assessment) {
    const update: (SubtaskProgress|null)[] = [] ;

    for (let i=0 ; i<this.task!.subtasks.length ; i++) {
      if (i== index) {
        update.push({status, assessment});
      } else {
        update.push(null);
      }
    }

    console.log(update) ;

    if (this.assessing) {
      let groupOrUserId = (this.task!.forGroups) ? this.response?.groupId! : this.response!.userIds![0] ;
      this.response = await firstValueFrom(this.$tasks.updateProgress(this.task!.id!, groupOrUserId, update)) ;
    } else {
      this.response = await firstValueFrom(this.$tasks.updateMyProgress(this.task!.id!, update));
    }

    this.handleProgressChanged();
  }

  setSubtaskIndex(index: number) {
    this.subtaskIndex = index ;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.handleProgressChanged();
  }


}
